import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        api_loading: false,
        aws_loading: false,
        
    },
    mutations: {
        
    },
    actions: {
        
    },
    getters: {},
    modules: {
        login,
    }
})